import { createFileRoute } from "@tanstack/react-router";
import { FakePayPanel } from "@/features/billing/fake-pay/panel";
import { m } from "@/lib/paraglide/messages.js";

// /billing/fake-pay/:reference: the fake gateway's payment page (docs/plans/billing-top-up.md §5,
// §7), where its pay_url points. Pay or Fail, then back to the top-ups, where the result shows. In
// production the API has no fake, so the page says the payment was not found.
export const Route = createFileRoute("/_authenticated/billing/fake-pay/$reference")({
  staticData: { crumb: m.billing_fake_pay_title },
  component: FakePayPage,
});

function FakePayPage() {
  const { reference } = Route.useParams();
  const navigate = Route.useNavigate();
  return <FakePayPanel reference={reference} onDone={() => void navigate({ to: "/billing/top-ups" })} />;
}
